import { Components, Theme } from '@mui/material/styles';

export const MuiSwitch: Components<Theme>['MuiSwitch'] = {
  styleOverrides: {
    track: {
      backgroundColor: 'var(--palette-text-secondary)',
    },
  },
};
